import type { Theme } from '../types';
import './ThemeToggle.css';

interface ThemeToggleProps {
  theme: Theme;
  onToggle: () => void;
}

export function ThemeToggle({ theme, onToggle }: ThemeToggleProps) {
  const next: Theme = theme === 'dark' ? 'light' : 'dark';
  const label = `Switch to ${next} theme`;

  return (
    <button
      type="button"
      onClick={onToggle}
      className="theme-toggle"
      aria-label={label}
      title={label}
    >
      <span className={`theme-toggle-track theme-${theme}`}>
        <span className="theme-toggle-thumb" />
      </span>
    </button>
  );
}
